import React from 'react';
import { useIntl } from '../../util/reactIntl';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import { IconReviewStar, ValidationError } from '../../components';

import css from './FieldReviewRating.module.css';

const FieldReviewRatingComponent = props => {
  const {
    rootClassName,
    className,
    customErrorText,
    id,
    intl,
    label,
    input,
    meta,
  } = props;

  const { touched, error } = meta;
  const errorText = customErrorText || error;
  const fieldMeta = { touched, error: errorText };

  const classes = classNames(rootClassName || css.root, className);

  // ✅ Debug logs
  console.log('🔍 FieldReviewRating current value:', input.value);
  console.log('🔍 Input object:', input);

  const createStarRating = starCount => {
    let inputsAndLabels = [];

    for (let i = starCount; i > 0; i--) {
      const inputValue = `${i}`;
      const starId = `star${i}`;
      const inputId = `${id}.${starId}`;
      
      // ✅ Check if this star should be checked
      const isChecked = input.value ? input.value === inputValue : false;

      inputsAndLabels.push(
        <input
          key={inputId}
          id={inputId}
          className={css.rateInput}
          type="radio"
          name={input.name}
          value={inputValue}
          checked={isChecked}
          onChange={e => {
            console.log('⭐ Star clicked:', e.target.value);
            console.log('⭐ Calling input.onChange with:', e.target.value);
            // ✅ Call onChange with the value directly
            input.onChange(e.target.value);
          }}
          onBlur={input.onBlur}
          onFocus={input.onFocus}
        />
      );

      inputsAndLabels.push(
        <label
          key={`label.${inputId}`}
          className={css.label}
          htmlFor={inputId}
          title={intl.formatMessage({ id: `FieldReviewRating.${starId}` })}
        >
          <IconReviewStar
            rootClassName={css.star}
            ariaLabel={intl.formatMessage({ id: `FieldReviewRating.${starId}` })}
          />
        </label>
      );
    }
    return inputsAndLabels;
  };

  return (
    <div className={classes}>
      <fieldset className={css.ratingFieldSet}>
        {label ? <legend>{label}</legend> : null}
        <div className={css.rating}>{createStarRating(5)}</div>
      </fieldset>
      <ValidationError fieldMeta={fieldMeta} />
    </div>
  );
};

/**
 * Final Form Field containing review rating 'stars'
 * ✅ Using Field component with proper render function
 */
const FieldReviewRating = props => {
  const intl = useIntl();
  
  return (
    <Field
      name={props.name}
      validate={props.validate}
      render={fieldRenderProps => {
        const { input, meta } = fieldRenderProps;
        return (
          <FieldReviewRatingComponent
            {...props}
            intl={intl}
            input={input}
            meta={meta}
          />
        );
      }}
    />
  );
};

export default FieldReviewRating;